(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-item');
    
    accordionItems.forEach(item => {
      item.addEventListener('toggle', function() {
        if (this.open) {
          accordionItems.forEach(otherItem => {
            if (otherItem !== this && otherItem.open) {
              otherItem.open = false;
            }
          });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
